import { render, staticRenderFns } from "./SortableColumnHeader.vue?vue&type=template&id=29573a18&"
import script from "./SortableColumnHeader.vue?vue&type=script&lang=js&"
export * from "./SortableColumnHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports